module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-check-box",
    class: {
      show: _vm.focus
    }
  }, [_c('input', {
    staticClass: "hide-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": _vm.handleKeyup,
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "k-check-box",
    class: {
      checked: _vm.value
    },
    on: {
      "click": _vm.checkedHandle
    }
  }, [(_vm.value) ? _c('k-icon', {
    attrs: {
      "xlink": "#icon-checked"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f5a674","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KCheckBox.vue
// module id = 119
// module chunks = 1